import React from "react";
import { Link } from "react-router-dom";
import brand from "../content/brand";
import services from "../content/services";

const Footer = () => (
  <footer className="foot">
    <div className="shell">
      <div className="grid">
        <div className="lead-block">
          <img src="/brand/cmv-logo.png" alt={brand.name} className="footer-logo" />
          <p>{brand.pitch}</p>
        </div>

        <div>
          <h5>Capabilities</h5>
          {services.slice(0, 5).map((s) => (
            <Link key={s.slug} to={`/capabilities/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>More</h5>
          {services.slice(5).map((s) => (
            <Link key={s.slug} to={`/capabilities/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>Studio</h5>
          <Link to="/approach">Approach</Link>
          <Link to="/studio">Studio</Link>
          <Link to="/contact">Contact</Link>
          <a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
        </div>
      </div>

      <div className="colophon">
        <span>© {new Date().getFullYear()} {brand.legal}. All rights reserved.</span>
        <span>{brand.hq.city}, {brand.hq.country}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
